import React from 'react';
import PropTypes from 'prop-types';
import { HighlightsButton, HighlightsDivider, HighlightsWrapper } from './Highlights.style';
import { HighlightsVideoList } from './components/HighlightVideoList';
import { HighlightTVList } from './components/HighlightTVList';
const buttonProps = {
    iconName: 'carousel-arrow-right',
    iconLeft: false
};

export const HighlightButton = (props) => <HighlightsButton {...buttonProps} {...props} $isMobile={props.isMobile}>{props?.children}</HighlightsButton>;

export const Highlights = ({
    showHighlightVideos,
    showMLBTVInfo,
    isMobile
}) => {
    return (
        <>
            {(showHighlightVideos || showMLBTVInfo) && <HighlightsDivider />}
            <HighlightsWrapper $isMobile={isMobile}>
                {showHighlightVideos && <HighlightsVideoList isMobile={isMobile} />}
                {showMLBTVInfo && <HighlightTVList isMobile={isMobile} />}
            </HighlightsWrapper>
        </>
    );
};

Highlights.propTypes = {
    showMLBTVInfo: PropTypes.bool,
    showHighlightVideos: PropTypes.bool,
    isMobile: PropTypes.bool
};

HighlightButton.propTypes = {
    children: PropTypes.node,
    isMobile: PropTypes.bool
};
